import React, { useEffect, useMemo } from 'react';

import { Trans } from '@lingui/macro';
import { Button, Grid, Typography } from '@mui/material';
import { useTour } from '@reactour/tour';

import { Information } from 'src/components/typography';
import useCancelTourOnUnmount from 'src/tours/cancelTourOnUnmount';
import { useUserTourPolicy } from 'src/tours/tourPolicy';

import TourContentWithDecline from './tourContentWithDecline';

export const useProjectDetailsTour = () => {
    useCancelTourOnUnmount();
    const { shouldDisplay, onTourShown, onTourDeclined, onTourFinished } =
        useUserTourPolicy('ProjectDetailsTour');
    const { setIsOpen, setSteps, setCurrentStep } = useTour();
    const computedSteps = useMemo(() => {
        const handleClose = () => {
            setIsOpen(false);
            setCurrentStep(0);
        };
        const tourSteps = [
            {
                selector: '[data-testid="projectDetails"]',
                content: (
                    <Information
                        title={<Trans>Rfp details</Trans>}
                        value={
                            <TourContentWithDecline onTourDeclined={onTourDeclined}>
                                <Typography>
                                    <Trans>
                                        In this step you will define the details of your RFP. This
                                        ranges from the project setup over the proposal contents to
                                        the timeline of the RFP.
                                    </Trans>
                                </Typography>
                                <Grid container justifyContent="flex-end">
                                    <Button
                                        color="success"
                                        variant="contained"
                                        onClick={handleClose}
                                    >
                                        <Trans>Done</Trans>
                                    </Button>
                                </Grid>
                            </TourContentWithDecline>
                        }
                    />
                ),
                actionAfter: onTourFinished,
                stepInteraction: false,
            },
        ];

        return tourSteps;
    }, []);

    useEffect(() => {
        setSteps(computedSteps);
        if (shouldDisplay) {
            onTourShown();

            setTimeout(() => setIsOpen(true), 1000);
        }
    }, [
        shouldDisplay,
        onTourShown,
        onTourDeclined,
        onTourFinished,
        setSteps,
        setIsOpen,
        computedSteps,
    ]);
};
